module.exports = __webpack_public_path__ + "659fc09692c3c208bb8728b9b3eb4c81.png";